import React from "react";
import { Link } from "react-router-dom";
import logoimg from "../assets/images/Logo.png";
import { FaLink, FaGithub, FaLinkedin, FaTwitterSquare } from "react-icons/fa";

const Footer = () => {
  const currentYear = new Date().getFullYear();
  return (
    <>
      <footer>
        <div className="app__footer">
          <div className="app__footer-container1">
            <div className="app__navbar-logo">
              <a href="#home" className="nav-xbtext">
                <img src={logoimg} alt="site-logo" />
                <span>UrchDev</span>
              </a>
            </div>
            <div>
              <p>Fullstack Developer</p>
            </div>
          </div>

          <div className="app__footer-container2">
            <p>Media</p>
            <div className="media-links">
              <a href="www.linkedin.com/in/urch-ezedinma-3b4451295">
                <FaLinkedin />
              </a>
              <a href="https://github.com/Kelviz">
                <FaGithub />
              </a>
              <a href="https://twitter.com/UrchDev">
                <FaTwitterSquare />
              </a>
            </div>
          </div>
        </div>

        <div className="footer-copyright">
          <p>© Copyright {currentYear}. Made by UrchDev</p>
        </div>
      </footer>

      <div className="app__top-media">
        <div className="media-line"></div>
        <div className="top__media-links">
          <a href="www.linkedin.com/in/urch-ezedinma-3b4451295">
            <FaLinkedin />
          </a>
          <a href="https://github.com/Kelviz">
            <FaGithub />
          </a>
          <a href="https://twitter.com/UrchDev">
            <FaTwitterSquare />
          </a>
        </div>
      </div>
    </>
  );
};

export default Footer;
